module.exports = __webpack_public_path__ + "static/flags/MT-caa82edd30304eb59f19a677fab01cfe.gif";